import React, {useRef} from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import FieldSelectView from "../../select-view"
import VScroll from "../../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import FieldSelectView_PopoverOption from "./popover-option"
import PopoverMenuOption from "../../../../../../gd-components/popover-menu/popover-menu/menu-option";

const debug = false
// const debug = "FieldSelectView_Popover"

export default function FieldSelectView_Popover(props:any) {

    const refNewView: any = useRef()

    const onClickOutside = (e:any) => {
        if (refNewView.current?.isPopoverShown) return
        // if (gd.utils.Dom.findNodeByClassName(e.target, ["top-project-views-popover", "popover-project-view"])) return

        props.parent.hidePopover()
    }

    const onSelect = (value:ID) => {
        debug && console.log(debug, 'onSelect', value)

        props.parent.hidePopover()
        props.parent.onValueChange(value)
    }

    const field : FieldSelectView = props.field
    const value = field.getViewValue(props.model)

    debug && console.log(debug, 'render', value, field.views, props.model)

    const onCustomize = ()=> {
        props.model.toggleIsCompactMenu()
    }

    const customizeOption = {
        icon    : "i5-expand-top",
        label   : "Show menu"
    }

    return (
        <Popover
            position                = {PopoverPosition.bottomCenter()}
            onClickOutside          = {onClickOutside}
            outsideClickIgnoreClass = "view-more-submenu-item"
            clickOutsideDelay       = {300}
            getTargetFunc           = {()=>findDOMNode(props.parent)}
        >
            <div className="ui5-popover-menu with-help w-200 flex-column-left-top">
                <VScroll containerClass="max-h-400">
                    {_.map(field.views, view =>{
                        return (
                            <FieldSelectView_PopoverOption
                                key         = {view.id}
                                view        = {view}
                                isSelected  = {view.id === value}
                                onSelect    = {onSelect}
                            />
                        )
                    })}
                </VScroll>

                <div className="w-100p">
                    <div className="separator"/>
                    <PopoverMenuOption
                        className   = "m-b-5"
                        option      = {customizeOption}
                        onClick     = {onCustomize}
                        isSelected  = {false}
                    />
                </div>
            </div>
        </Popover>
    )
}
